import React from 'react';
import { Input } from 'antd';

import "./style.scss"

const SearchInput = ({ onSearch, width, onChange, className, placeholder = "Search" }) => (
  <div className={`search-input-wrapper ${className || ''}`} style={{ width: width || '100%' }}>
    <Input 
      placeholder={placeholder} 
      onChange={onChange} 
      onPressEnter={(e) => onSearch && onSearch(e.target.value)}
      style={{ width: '100%' }} 
      className="custom-search-input"
    />
  </div>
);

export default SearchInput;